import React from 'react'
import { Global, css } from '@emotion/core'

export const CarouselStyle = ({
  dotsColor = '#9fcf66',
  dotsColor_hover = '#7fa652',
  arrowColor = '#fff',
  arrowColor__hover = '#fff',
  arrowSize = '10px',
  arrowWeight = '3px',
  disabledButtonColor = '#cccccc',
  clickableAreaSize = '42px',
  clickableAreaColor = '#c50f3c',
  clickableAreaColor__hover = '#9e0c30',
}) => (
  <Global
    styles={css`
      /* -------- CAROUSEL -------- */

      .BrainhubCarousel__container {
        width: 100%;
        height: 100%;
        /* overflow: hidden; */
        position: relative;
      }
      .BrainhubCarousel {
        height: 100%;
        /* overflow: hidden; */
        display: flex;
        align-items: center;
      }
      .BrainhubCarousel.BrainhubCarousel--isRTL {
        direction: rtl;
      }
      .BrainhubCarousel.BrainhubCarousel--isRTL
        .BrainhubCarousel__trackContainer
        .BrainhubCarousel__track {
        direction: rtl;
      }
      .BrainhubCarousel .BrainhubCarousel__trackContainer {
        overflow: hidden;
        height: 100%;
      }
      .BrainhubCarousel .BrainhubCarousel__trackContainer .BrainhubCarousel__track {
        display: flex;
        overflow: hidden;
        list-style: none;
        margin: 0;
        padding: 0;
        height: 100%;
      }
      .BrainhubCarousel
        .BrainhubCarousel__trackContainer
        .BrainhubCarousel__track.BrainhubCarousel__track--transition {
        transition: transform;
      }
      /* arrows */
      .BrainhubCarousel__arrows {
        cursor: pointer;
      }

      /* -------- CAROUSEL DOTS -------- */

      .BrainhubCarousel__dots {
        display: flex;
        justify-content: center;
        list-style: none;
        margin: 0;
        padding: 0;
        font-size: 0;
        line-height: 0;
        margin-top: 5px;
      }
      .BrainhubCarousel__dots.BrainhubCarousel__dots--isRTL {
        direction: rtl;
      }
      .BrainhubCarousel__dots .BrainhubCarousel__dot {
        outline: 0;
        padding: 10px;
        border: none;
        font-size: 0;
        cursor: pointer;
        -webkit-appearance: none;
      }
      .BrainhubCarousel__dots .BrainhubCarousel__dot.BrainhubCarousel__dot--selected:before {
        background: ${dotsColor};
      }
      .BrainhubCarousel__dots .BrainhubCarousel__dot:before:hover {
        background: ${dotsColor_hover};
      }
      .BrainhubCarousel__dots .BrainhubCarousel__dot:before {
        content: '';
        display: block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        padding: 0;
        border: none;
        background: rgba(0, 0, 0, 0.16);
      }
      .BrainhubCarousel__dots .BrainhubCarousel__thumbnail {
        outline: 0;
        padding: 10px;
        border: none;
        opacity: 0.5;
        font-size: 0;
        cursor: pointer;
      }
      .BrainhubCarousel__dots .BrainhubCarousel__thumbnail.BrainhubCarousel__thumbnail--selected {
        opacity: 1 !important;
      }
      .BrainhubCarousel__dots .BrainhubCarousel__thumbnail:hover {
        opacity: 1;
      }
      .BrainhubCarousel__thumbnail[type='button'] {
        -webkit-appearance: none;
      }
      .BrainhubCarousel--isRTL + .BrainhubCarousel__dots {
        direction: rtl;
      }

      /* -------- CAROUSEL ITEM -------- */

      .BrainhubCarouselItem {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
      }
      .BrainhubCarouselItem.BrainhubCarouselItem--clickable {
        cursor: pointer;
      }
      .BrainhubCarouselItem .debug-number {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        font-size: 2em;
        text-shadow: 0px 0px 9px white;
      }

      /* -------- CAROUSEL ARROWS -------- */

      .BrainhubCarousel__arrows {
        position: relative;
        padding: calc(${clickableAreaSize} / 2);
        border: none;
        overflow: hidden;
        outline: 0;
        font-size: 0;
        line-height: 0;
        background-color: ${clickableAreaColor};
      }
      .BrainhubCarousel__arrows span {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        border-style: solid;
        border-color: ${arrowColor};
        border-width: ${arrowWeight} ${arrowWeight} 0 0;
        padding: calc(${arrowSize} / 2);
        transition: 0.3s;
        font-size: 0;
      }
      .BrainhubCarousel__arrows:hover {
        background-color: ${clickableAreaColor__hover};
      }
      .BrainhubCarousel__arrows:hover span {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        border-style: solid;
        border-color: ${arrowColor};
        border-width: ${arrowWeight} ${arrowWeight} 0 0;
        padding: calc(${arrowSize} / 2);
        transition: 0.3s;
        font-size: 0;
      }
      .BrainhubCarousel__arrows:hover:enabled {
        background-color: ${clickableAreaColor__hover};
      }
      .BrainhubCarousel__arrows:hover:enabled span {
        border-color: ${arrowColor__hover};
        margin: 0;
      }
      .BrainhubCarousel__arrows:disabled {
        background-color: ${disabledButtonColor};
      }
      .BrainhubCarousel__arrowLeft span {
        transform: translate(-50%, -50%) rotate(-135deg);
        margin-left: calc(0.35 * (${arrowSize} - ${arrowWeight}));
      }
      .BrainhubCarousel__arrowRight span {
        transform: translate(-50%, -50%) rotate(45deg);
        margin-left: calc(-0.35 * (${arrowSize} - ${arrowWeight}));
      }
      .BrainhubCarousel--isRTL .BrainhubCarousel__arrowLeft span {
        transform: translate(-50%, -50%) rotate(45deg);
        margin-left: calc(-0.35 * (${arrowSize} - ${arrowWeight}));
      }
      .BrainhubCarousel--isRTL .BrainhubCarousel__custom-arrowLeft span {
        transform: rotate(180deg);
      }
      .BrainhubCarousel--isRTL .BrainhubCarousel__arrowRight span {
        transform: translate(-50%, -50%) rotate(-135deg);
        margin-left: calc(0.35 * (${arrowSize} - ${arrowWeight}));
      }
      .BrainhubCarousel--isRTL .BrainhubCarousel__custom-arrowRight span {
        transform: rotate(-180deg);
      }
      .BrainhubCarousel--isRTL .BrainhubCarousel__arrows:hover span {
        margin: 0;
      }
      .BrainhubCarousel__arrow--disable {
        pointer-events: none;
      }
    `}
  />
)

export default CarouselStyle
